// @ts-nocheck

import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

export default function HeaderSection({ backLink, title }) {
  return (
    <div>
      {backLink && (
        <div style={styles.backLinkContainer}>
          <Link to={backLink} style={styles.backLink}>
            &lt; Back
          </Link>
        </div>
      )}
      <div style={styles.headingContainer}>
        <h2 style={styles.heading}>{title}</h2>
      </div>
    </div>
  )
}

const styles = {
  backLinkContainer: {
    marginBottom: 30
  },
  backLink: {
    fontWeight: 600,
    fontSize: 14
  },
  divider: {
    height: 2,
    marginBottom: 0,
    width: '100%'
  },
  heading: {
    marginBottom: '0.3em',
    textOverflow: 'ellipsis',
    hyphens: 'auto',
    marginRight: 20
  },
  headingContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  }
}

HeaderSection.propTypes = {
  backLink: PropTypes.string,
  title: PropTypes.string
}
